const initialState = {
    currentHirer: {},
    currentTrial: {},
    currentProvisioning: {}
};

export default function adminBilling(state = initialState, action) {
    switch (action.type) {
        case 'ADD_CURRENT_ADMIN_HIRER':
            return {
                ...state,
                currentHirer: action.hirer
            };
        case 'ADD_CURRENT_ADMIN_TRIAL':
            return {
                ...state,
                currentTrial: action.trial
            };
        case 'ADD_CURRENT_ADMIN_PROVISIONING':
            return {
                ...state,
                currentProvisioning: action.provisioning
            };
        default:
            return state;
    }
}
